import MainPage from '@/MainPage'

const routerArr = [
  {
    path: '/mail',
    name: 'MainPageEmail',
    component: MainPage,
    children: [
      {
        path: '/mail/:tab',
        name: 'TabOpen',
        component: MainPage
      },
      {
        path: ':tab/folder/:path',
        name: 'FolderOpen',
        component: MainPage
      },
      {
        path: ':tab/dialog/:dialog',
        name: 'EmailOpen',
        component: MainPage
      },
      {
        path: ':tab/template/:id',
        name: 'TemplateOpen',
        component: MainPage
      }
    ]
  }
]

if (process.env.NODE_ENV === 'development') {
  routerArr.push({
    path: '/',
    redirect: '/mail',
    name: 'index'
  })
}

export const ROUTER_LIST = routerArr



// WEBPACK FOOTER //
// ./src/constants/router.js